import React, { useEffect, useState } from "react";
import { useLazyQueryByIdQuery } from "../../service/customerSupport";
import MainContainer from "../../layout/MainContainer";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { CustomerSupportResponse } from "../../types/General";
import { errorToast } from "../../helpers";
import Loader from "../../constants/Loader";

const CustomerSupportDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [queryById] = useLazyQueryByIdQuery();

  const [loading, setLoading] = useState(false);
  const [queryDetails, setQueryDetails] =
    useState<CustomerSupportResponse | null>(null);

  const getQueryDetails = async (id: number) => {
    setLoading(true);

    try {
      const response = await queryById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setQueryDetails(response?.data);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getQueryDetails(Number(id));
    }
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title fdx">
        <div>
          <h1>Query Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/customer-support")}>Queries</span> -
            Query Detail
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <div className="profileInfo_list">
          <ul className="text_info gap_p">
            <li
              className="w_100"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <strong>User Image</strong>
              <span>
                <figure style={{ height: 150, width: 150 }}>
                  <img
                    src={
                      queryDetails?.profile_picture?.media_url ||
                      "/static/images/user_placeholder.png"
                    }
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </figure>
              </span>
            </li>
            <li
              className="w_50"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <strong>User name</strong>
              <span>
                {queryDetails?.first_name || "-"}{" "}
                {queryDetails?.middle_name || ""}{" "}
                {queryDetails?.last_name || ""}
              </span>
            </li>

            {Number(queryDetails?.type) === 2 ? (
              <li
                className="w_100"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <strong>Subject</strong>
                <span>{queryDetails?.subject || "-"}</span>
              </li>
            ) : null}

            <li
              className="w_100"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <strong>Query</strong>
              <span>{queryDetails?.description || "-"}</span>
            </li>
            <li
              className="w_100"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <strong>Revert</strong>
              <span>{queryDetails?.answer || "-"}</span>
            </li>

            <li className="w_50" />
          </ul>
        </div>
      </div>
    </MainContainer>
  );
};

export default CustomerSupportDetail;
